import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
declare var $: any;
@Component({
  selector: 'app-wipe',
  templateUrl: './wipe.component.html',
})
export class WipeComponent implements OnInit {
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })
  constructor(private _router: Router, private _Service: ApiService,
    private activatedRoute: ActivatedRoute, private _toastr: ToastrService, private location: Location) { }
  isLoading: boolean = false;
  isLock: boolean = false;
  deviceId: string = '';
  sendCommanddto: SendCommandDto = new SendCommandDto();
  ngOnInit(): void {
    this.deviceId = this.activatedRoute.snapshot.params["id"];
    this.getDevicesInUser()
  }
  mobileDevice: any[] = [];
  deviceName: any
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._Service.getService(this._Service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach((element: any) => {
              if (this.deviceId == element.id) {
                this.deviceName = element.deviceName;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(element.id);
              }
            });
          }
          else {
            let deviceId = response.data[0].id;
            this.restorePublishForm.controls['mobileDeviceName'].setValue(deviceId);
          }
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  onMobileDeviceSelect(event: any) {
    this.deviceId = event.target.value;
    this.mobileDevice.forEach(element => {
      if (this.deviceId == element.id) {
        this.deviceName = element.name;
      }
    });
  }
  goBack() {
    this.location.back()
  }

  openLockModal() {
    $("#LockPopup").modal("show");
    this.isLock = false
  }

  isLockClicked() {
    this.isLock = true
  }

  // Send Command
  errorMessage: string = ''
  sendCommand() {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = 'WIPE'
      this._Service.postService(this._Service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          this.isLock = true
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
        this.isLoading = false;
      })
    } catch (error) {
      this.isLoading = false;
    }
  }


  //  Closing the modal
  closeModal() {
    $("#LockPopup").modal("hide");
    this.isLock = false;
    this.errorMessage = '';
  }
}
